<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-staff modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ข้อมูลเจ้าหน้าที่</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <template v-if="!isShowNetworkError">
                            <div class="form" v-if="!isLoading && formData">
                                <div class="field">
                                    <label>อีเมล (สำหรับเข้าสู่ระบบ)</label>
                                    <input type="text"
                                        class="input-field"
                                        :class="{ 'invalid': errorData.email.blank }"
                                        :readonly="staffId"
                                        maxlength="100"
                                        placeholder="อีเมล"
                                        v-model="formData.email" />
                                    <div class="input-error-message" v-if="errorData.email.blank">โปรดใส่อีเมล</div>
                                </div>
                                <div class="field">
                                    <label>ชื่อเจ้าหน้าที่</label>
                                    <input type="text"
                                        class="input-field"
                                        :class="{ 'invalid': errorData.staffName.blank }"
                                        maxlength="100"
                                        placeholder="ชื่อเจ้าหน้าที่"
                                        v-model="formData.staffName" />
                                    <div class="input-error-message" v-if="errorData.staffName.blank">โปรดกรอกชื่อเจ้าหน้าที่</div>
                                </div>
                                <div class="field">
                                    <label>บทบาท</label>
                                    <dropdown
                                        v-model="formData.level"
                                        placeholder="-- บทบาทเจ้าหน้าที่ --"
                                        :options="option.staffRole"
                                        :classes="{ input: ['input-field', (errorData.level.blank ? 'invalid' : '')] }"
                                    ></dropdown>
                                    <div class="input-error-message" v-if="errorData.level.blank">โปรดเลือกบทบาทเจ้าหน้าที่</div>
                                </div>
                                
                                <div class="mt-4 text-right">
                                    <button class="btn btn-main" @click="saveStaff()">บันทึก</button>
                                    <button class="btn btn-grey-outline" @click="hide()">ปิด</button>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="no-data">
                                <b-icon icon="exclamation-diamond"></b-icon>
                                <span>ข้อมูลส่วนต้องใช้การเชื่อมต่ออินเทอร์เน็ต โปรดตรวจสอบการเชื่อมต่อของอุปกรณ์ที่ท่านใช้</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import OptionStaffRole from '@/database/staticOption/StaffRole';
import Helper from '@/resources/Helper';

export default {
    components: {
    },
    data() {
        return {
            isActive: false,
            isLoading: true,
            isShowNetworkError: false,
            formData: null,
            errorData: null,
            option: { staffRole: OptionStaffRole.option }
        };
    },
    props: {
        isDisplay: Boolean,
        staffId: Number
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.loadStaffData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        initFormData(data) {
            return {
                id: data ? data.id : '',
                email: data ? data.email : '',
                staffName: data ? data.staffName : '',
                level: data ? data.level : ''
            }
        },
        initValidateData() {
            return {
                email: { blank: false },
                staffName: { blank: false },
                level: { blank: false }
            }
        },
        async loadStaffData() {
            if (this.staffId) {
                this.isLoading = true;
                this.isShowNetworkError = false;

                const param = {
                    id: this.staffId
                };

                const result = await Helper.postAPI(Helper.getApiUrl(), '/api/store/get-staff-detail', param, Helper.getHeaderToken());

                if (result) {
                    this.formData = this.initFormData(result.data);
                } else {
                    this.isShowNetworkError = true;
                }

                this.isLoading = false;
            } else {
                this.formData = this.initFormData(null);
                this.isLoading = false;
            }
        },
        async saveStaff() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                const result = await Helper.postAPI(Helper.getApiUrl(), '/api/store/save-staff', this.formData, Helper.getHeaderToken());

                if (result) {
                    if (result.data.success) {
                        if (!this.staffId) {
                            this.$swal({
                                title: result.data.data,
                                text: 'โปรดเก็บรหัสผ่านนี้ไว้ให้เจ้าหน้าที่ของท่าน',
                                icon: 'info',
                                confirmButtonText: 'รับทราบ'
                            }).then(() => {
                                this.$emit('hide', null);
                            });
                        } else {
                            this.$emit('hide', null);
                        }
                    } else {
                        this.$swal({
                            title: result.data.message,
                            text: 'โปรดทำรายการใหม่อีกครั้ง',
                            icon: 'info',
                            confirmButtonText: 'รับทราบ'
                        });
                    }
                } else {
                    this.isShowNetworkError = true;
                }

                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (typeof this.formData[property] === 'string' || this.formData[property] instanceof String) {
                    if (!this.formData[property].trim()) {
                        this.errorData[property].blank = true;
                        valid = false;
                    }
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-staff {
    max-width: 400px;
}
</style>